(function(){
    angular
        .module('appback')
        .directive('ngFinalizarhoja', finalizarCont);
        finalizarCont.$inject = ['HojaService','GenerallabService','$timeout'];
        function finalizarCont(HojaService,GenerallabService,$timeout){
            return {
	            //require: 'ngModel',
              templateUrl: '/backend/hojafabricacion/template?name=finalizarhoja.twig',
		        scope: {
                  hc:'=',
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
                        scope.stockParaDesechar = false;
		            	scope.getExtraLote = function(stock){
                            var stockMat = {"nodetype":"stock_materiales","where":{"material_id": [stock.material_id],"cantidad:>":"0.00","cantidad:!=": ""}};
                            return stockMat;
                        }

                        scope.openModalDesechado = function(stock) {
                            scope.stockParaDesechar = stock;
                            $('#confirmarDesechadoModal').modal('show');
                        };

                        scope.confirmarStockDesechado = function() {
                            $('#confirmarDesechadoModal').modal('hide');
                            console.log("stock desechado", scope.stockParaDesechar)
                            HojaService.desecharStock(scope.stockParaDesechar.stock_seleccionado.id, function(data){
                                console.log("data desechado",data);
                                if(data.code > 0){
                                    scope.stockParaDesechar.stock_seleccionado.desechado = true;
                                }
                            })
                        };
			        });
		        }
          }
      }
})();